import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import CataloguePartsGrid from './CataloguePartsGrid';
import { IApplicationState } from 'ducks/reducers';
import { selectors as staffSelectors } from 'ducks/staff';

const mapStateToProps = (state: IApplicationState) => ({
    DefaultWarehouse: staffSelectors.staff(state)?.defaultWarehouseEntity
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {},
  dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CataloguePartsGrid);
